import React, { Component } from "react"
import styles from "./index.less"
import ResizableDialog from "@cirrus/legacy/app-components/dialogs/resizable-dialog"

class ResizablePdfDialog extends Component {
  render() {
    const { className, containerClassName, zIndex } = this.props
    return (
      <div
        className={
          containerClassName ? `${styles.container} ${containerClassName}` : styles.container
        }>
        <ResizableDialog
          {...this.props}
          className={className ? `${styles.dialog} ${className}` : styles.dialog}
          modalClassName={styles.modalClassName}
          contentClassName={styles.dialogContent}
          mainContentClassName={styles.mainContentClassName}
          mainClassName={styles.main}
          minResizeWidth={400}
          minResizeHeight={300}
          zIndex={zIndex}
        />
      </div>
    )
  }
}

export default ResizablePdfDialog
